import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { UzurvDirectivesModule } from '@uzurv/core';
import { RiderPhoneNumberComponent } from './rider-phone-number.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatRadioModule,
    UzurvDirectivesModule
  ],
  exports: [RiderPhoneNumberComponent],
  declarations: [RiderPhoneNumberComponent]
})
export class RiderPhoneNumberModule {}
